
import { getSubCategories, getCategories } from "./services/categoryService";

// Wrapper to maintain compatibility with code using SUB_CATEGORY_MAP[category]
// Since we are moving to a dynamic service, we use a Proxy or a getter approach if possible, 
// but for simplicity in this specific project structure, we will just export the service functions directly 
// and update consumers.
//
// However, to satisfy the specific request "update constant", we can re-construct the object dynamically
// for legacy support if needed, BUT it is better to update the consumers to use the service.
// 
// For now, we will expose the map dynamically built from the service to avoid breaking imports immediately.

export const SUB_CATEGORY_MAP: Record<string, string[]> = {};

getCategories().forEach(cat => {
    SUB_CATEGORY_MAP[cat] = getSubCategories(cat);
});
